
(function() {
  const originalElementQS = Element.prototype.querySelector;
  Element.prototype.querySelector = function(selector) {
    if (this === null || this === undefined) {
      return null;
    }
    try {
      return originalElementQS.call(this, selector);
    } catch (e) {
      return null;
    }
  };
  
  const originalGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  Object.getOwnPropertyDescriptor = function(obj, prop) {
    if (obj === null || obj === undefined) {
      return undefined;
    }
    return originalGetOwnPropertyDescriptor.call(this, obj, prop);
  };
  
  window.addEventListener('error', function(e) {
    if (e.message.includes('querySelector') || e.message.includes('Cannot read properties of null')) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  });
  
  const originalQuerySelector = Element.prototype.querySelector;
  const originalDocumentQuerySelector = Document.prototype.querySelector;
  
  window.addEventListener('DOMContentLoaded', function() {
    const hasCart = document.querySelector('.cart, [data-cart], #cart, .cart-form');
    const hasCartItems = document.querySelector('.cart-items, [data-cart-items], .cart__items');
    
    if (!hasCart || !hasCartItems) {
      if (window.theme && window.theme.Cart) {
        window.theme.Cart.init = function() {
          return false;
        };
      }
      
      if (window.Shopify && window.Shopify.CartJS) {
        window.Shopify.CartJS.init = function() {
          return false;
        };
      }
      
      if (!hasCart) {
        const fakeCart = document.createElement('div');
        fakeCart.className = 'cart';
        fakeCart.style.display = 'none';
        document.body.appendChild(fakeCart);
      }
      
      if (!hasCartItems) {
        const fakeCartItems = document.createElement('div');
        fakeCartItems.className = 'cart-items';
        fakeCartItems.style.display = 'none';
        document.body.appendChild(fakeCartItems);
      }
    }
  }, false);
  
  Element.prototype.querySelector = function(selector) {
    if (this === null || this === undefined) {
      const fakeDiv = document.createElement('div');
      fakeDiv.querySelector = () => null;
      return fakeDiv;
    }
    try {
      return originalQuerySelector.call(this, selector);
    } catch (error) {
      return null;
    }
  };
  
  Document.prototype.querySelector = function(selector) {
    try {
      return originalDocumentQuerySelector.call(this, selector);
    } catch (error) {
      return null;
    }
  };
  
  const protectedSelectors = [
    '.cart',
    '.cart-items',
    '.quantity-selector',
    '[data-quantity-field]',
    '.quantity-input',
    '.cart-quantity'
  ];
  
  document.addEventListener('DOMContentLoaded', function() {
    protectedSelectors.forEach(selector => {
      if (!document.querySelector(selector)) {
        const placeholder = document.createElement('div');
        placeholder.className = selector.replace('.', '').replace('[', '').replace(']', '');
        placeholder.style.display = 'none';
        document.body.appendChild(placeholder);
      }
    });
  });
})();

const originalQuerySelector = Document.prototype.querySelector;
Document.prototype.querySelector = function(selector) {
  try {
    return originalQuerySelector.call(this, selector);
  } catch (error) {
    return null;
  }
};

const originalElementQuerySelector = Element.prototype.querySelector;
Element.prototype.querySelector = function(selector) {
  try {
    if (this === null || this === undefined) {
      return null;
    }
    return originalElementQuerySelector.call(this, selector);
  } catch (error) {
    return null;
  }
};

let progressBarTimeout;
function debounceProgressBar(callback, delay) {
  clearTimeout(progressBarTimeout);
  progressBarTimeout = setTimeout(callback, delay);
}

let updateCount = 0;
function updateProgressBar() {
  updateCount++;
  const MAX_LIMIT = 100;
  
  // Use current DOM instead of fetching (since mini cart is dynamic)
  // Only count cart items, not product form buttons
  let totalAmount = 0;
  const items = document.querySelectorAll('[data-item][data-sku-base-amount]');
  
  items.forEach((item, index) => {
  // Skip items with administration_type of "Vape" or "Batterie"
  const adminType = item.getAttribute('data-administration-type') || '';
  if (adminType === 'Vape' || adminType === 'Batterie') {
    return;
  }
  
  const baseAmount = parseFloat(item.getAttribute('data-sku-base-amount'));
  const multiplier = parseInt(item.getAttribute('data-multiplier') || '5', 10);
  const m = isNaN(multiplier) || multiplier < 1 ? 5 : multiplier;
  const quantityInput = item.querySelector('[data-quantity-field]');
  const rawQuantity = quantityInput ? parseInt(quantityInput.value) : 1;
  const quantity = !isNaN(rawQuantity) ? Math.max(1, Math.round(rawQuantity / m)) : 1;
  
  if (!isNaN(baseAmount) && !isNaN(quantity)) {
    totalAmount += baseAmount * quantity;
  }
});
  updateProgressDisplay(totalAmount, MAX_LIMIT);
}

function updateProgressDisplay(totalAmount, maxLimit) {
  const percentage = Math.min((totalAmount / maxLimit) * 100, 100);
  const isLimitReached = totalAmount > maxLimit;
  
  const progressFill = document.querySelector('[data-progress-fill]');
  const progressAmount = document.querySelector('[data-progress-amount]');
  const progressMessage = document.querySelector('[data-progress-message]');
  
  if (progressFill && progressAmount && progressMessage) {
    progressFill.style.width = percentage + '%';
    progressAmount.innerHTML = `${totalAmount} g/ml <span class="max-limit">von max. ${maxLimit} g/ml</span>`;
    
    progressFill.style.backgroundColor = '#5b663c';
    progressMessage.textContent = `Du kannst bis zu ${(maxLimit - totalAmount)} g/ml hinzufügen`;
    progressMessage.style.color = '#5b663c';
  }
  
  const checkoutButtons = document.querySelectorAll('.cart__checkout');
  const limitWarning = document.querySelector('[data-limit-warning]');
  
  checkoutButtons.forEach(button => {
    if (isLimitReached) {
      button.disabled = true;
      button.title = 'Cannot proceed - limit exceeded';
    } else {
      button.disabled = false;
      button.title = '';
    }
  });
  
  if (limitWarning) {
    if (isLimitReached) {
      limitWarning.style.display = 'block';
    } else {
      limitWarning.style.display = 'none';
    }
  }
  
  updateIncrementButtonStates(totalAmount, maxLimit);
}

function calculateCurrentTotal() {
  // Always use DOM method since cart.json doesn't have sku_base_amount
  let currentTotal = 0;
  
  // Try to get fresh cart HTML first
  try {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', '/cart?section_id=api-cart-items', false); // Synchronous
    xhr.send();
    
    if (xhr.status === 200) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(xhr.responseText, 'text/html');
      const items = doc.querySelectorAll('[data-sku-base-amount]');
      
      items.forEach(item => {
        // Skip items with administration_type of "Vape" or "Batterie"
        const adminType = item.getAttribute('data-administration-type') || '';
        if (adminType === 'Vape' || adminType === 'Batterie') {
          return;
        }
        
        const baseAmount = parseFloat(item.getAttribute('data-sku-base-amount'));
        const multiplier = parseInt(item.getAttribute('data-multiplier') || '5', 10);
        const m = isNaN(multiplier) || multiplier < 1 ? 5 : multiplier;
        const quantityInput = item.querySelector('[data-quantity-field]');
        const rawQuantity = quantityInput ? parseInt(quantityInput.value) : 1;
        const effectiveQty = !isNaN(rawQuantity) ? Math.max(1, Math.round(rawQuantity / m)) : 1;
        
        if (!isNaN(baseAmount) && !isNaN(effectiveQty)) {
          currentTotal += baseAmount * effectiveQty;
        }
      });
      
      return currentTotal;
    }
  } catch (error) {
    // Fallback to current DOM items
  }
  
  // Fallback to current DOM items
  const currentItems = document.querySelectorAll('[data-sku-base-amount]');
  currentItems.forEach(item => {
    // Skip items with administration_type of "Vape" or "Batterie"
    const adminType = item.getAttribute('data-administration-type') || '';
    if (adminType === 'Vape' || adminType === 'Batterie') {
      return;
    }
    
    const baseAmount = parseFloat(item.getAttribute('data-sku-base-amount'));
    const multiplier = parseInt(item.getAttribute('data-multiplier') || '5', 10);
    const m = isNaN(multiplier) || multiplier < 1 ? 5 : multiplier;
    const quantityInput = item.querySelector('[data-quantity-field]');
    const rawQuantity = quantityInput ? parseInt(quantityInput.value) : 1;
    const quantity = !isNaN(rawQuantity) ? Math.max(1, Math.round(rawQuantity / m)) : 1;
    
    if (!isNaN(baseAmount) && !isNaN(quantity)) {
      currentTotal += baseAmount * quantity;
    }
  });
  return currentTotal;
}

function updateIncrementButtonStates(currentTotal, maxLimit) {
  if (currentTotal >= 90) { // Only log when close to limit
    console.log(`🔒 Updating button states: ${currentTotal}g/ml of ${maxLimit}g/ml`);
  }
  
  const incrementButtons = document.querySelectorAll(`
    .qty__adjust-btn--plus,
    .qty__adjust-btn.qty__adjust-btn--plus,
    [data-quantity-plus],
    [data-quantity-button][data-action="increment"],
    .inputCounter__btn--up,
    .quantity__button--plus,
    .btn--plus,
    button[aria-label*="Increase"],
    button[title*="Increase"]
  `);
  
  if (currentTotal >= 90) {
    console.log(`🔍 Found ${incrementButtons.length} increment buttons to check`);
  }
  
  // Also handle decrement buttons - they should never be disabled by weight limits
  const decrementButtons = document.querySelectorAll(`
    .qty__adjust-btn--minus,
    .qty__adjust-btn.qty__adjust-btn--minus,
    [data-quantity-minus],
    [data-quantity-button][data-action="decrement"],
    .inputCounter__btn--down,
    .quantity__button--minus,
    .btn--minus,
    button[aria-label*="Decrease"],
    button[title*="Decrease"]
  `);
  
  // Always enable decrement buttons (they reduce weight, so they're always safe)
  decrementButtons.forEach(button => {
    button.disabled = false;
    button.title = '';
    button.style.removeProperty('opacity');
    button.style.removeProperty('cursor');
  });
  
  for (let i = 0; i < incrementButtons.length; i++) {
    const button = incrementButtons[i];
    const itemContainer = button.closest('[data-sku-base-amount]') || 
                         button.closest('[data-item]') ||
                         button.closest('.cart-item') ||
                         button.closest('.product-form') ||
                         button.closest('form');
    
    let shouldDisable = false;
    
    if (currentTotal >= maxLimit) {
      shouldDisable = true;
    } else if (itemContainer) {
      let baseAmount = parseFloat(itemContainer.getAttribute('data-sku-base-amount') || '0');
      
      if (baseAmount === 0) {
        const baseAmountInput = itemContainer.querySelector(`
          input[name="properties[sku_base_amount]"],
          input[name="properties[base_amount]"],
          input[name="properties[_base_amount]"],
          input[data-base-amount],
          [data-product-base-amount],
          [data-variant-base-amount],
          [data-sku-base-amount]
        `);
        
        if (baseAmountInput) {
          baseAmount = parseFloat(baseAmountInput.value || baseAmountInput.getAttribute('data-base-amount') || '0');
        }
      }
      
      if (baseAmount > 0) {
        const multiplierAttr = itemContainer.getAttribute('data-multiplier');
        const m = Math.max(1, parseInt(multiplierAttr || '5', 10));
        const addDelta = baseAmount; // one effective unit adds baseAmount g/ml
        shouldDisable = (currentTotal + addDelta) > maxLimit;
      } else {
        shouldDisable = currentTotal >= maxLimit;
      }
    } else {
      shouldDisable = currentTotal >= maxLimit;
    }
    
    if (shouldDisable) {
      if (currentTotal >= 90) {
        console.log(`🚫 DISABLING button ${i+1}: currentTotal=${currentTotal}, addDelta=${addDelta || 'unknown'}, class="${button.className}"`);
      }
      button.disabled = true;
      button.title = `Cannot add more - would exceed ${maxLimit}g/ml limit`;
      button.style.setProperty('opacity', '0.5', 'important');
      button.style.setProperty('cursor', 'not-allowed', 'important');
    } else {
      if (currentTotal >= 90) {
        console.log(`✅ KEEPING button ${i+1} enabled: currentTotal=${currentTotal}, addDelta=${baseAmount || 'unknown'}, class="${button.className}"`);
      }
      button.disabled = false;
      button.title = '';
      button.style.removeProperty('opacity');
      button.style.removeProperty('cursor');
    }
  }
}

function updatePlusButtonStates(currentTotal, maxLimit) {
  const plusButtons = document.querySelectorAll(`
    [data-quantity-plus],
    [data-quantity-button][data-action="increment"],
    .inputCounter__btn--up,
    .quantity__button--plus,
    .btn--plus,
    .qty__adjust-btn--plus,
    .qty__adjust-btn.qty__adjust-btn--plus,
    [aria-label*="Increase"],
    [title*="Increase"],
    .quantity-selector .btn:last-child,
    .quantity__input + .btn,
    button[data-quantity-button]:last-of-type
  `);

  plusButtons.forEach(button => {
    const itemContainer = button.closest('[data-sku-base-amount]') || 
                        button.closest('[data-item]') ||
                        button.closest('.cart-item') ||
                        button.closest('.product-form') ||
                        button.closest('form');
    
    if (itemContainer) {
      let baseAmount = parseFloat(itemContainer.getAttribute('data-sku-base-amount') || '0');
      
      if (baseAmount === 0) {
        const variantData = itemContainer.querySelector('[data-variant-base-amount]');
        const productMeta = itemContainer.querySelector('[data-product-base-amount]');
        
        if (variantData) {
          baseAmount = parseFloat(variantData.getAttribute('data-variant-base-amount') || '0');
        } else if (productMeta) {
          baseAmount = parseFloat(productMeta.getAttribute('data-product-base-amount') || '0');
        } else {
          const hiddenInput = itemContainer.querySelector('input[name*="base_amount"], input[data-base-amount]');
          if (hiddenInput) {
            baseAmount = parseFloat(hiddenInput.value || '0');
          }
        }
      }
      
      const multiplierAttr = itemContainer.getAttribute('data-multiplier');
      const m = Math.max(1, parseInt(multiplierAttr || '5', 10));
      const addDelta = baseAmount; // one effective unit adds baseAmount g/ml
      const wouldExceedLimit = (currentTotal + addDelta) > maxLimit;
      
      if (wouldExceedLimit && baseAmount > 0) {
        button.disabled = true;
        button.title = 'Cannot add more - limit would be exceeded';
      } else {
        button.disabled = false;
        button.title = '';
      }
    }
  });

  const quantityInputs = document.querySelectorAll('[data-quantity-field], input[name="quantity"]');
  quantityInputs.forEach(input => {
    const itemContainer = input.closest('[data-sku-base-amount]') || 
                        input.closest('[data-item]') ||
                        input.closest('.cart-item') ||
                        input.closest('.product-form');
    
    if (itemContainer) {
      const baseAmount = parseFloat(itemContainer.getAttribute('data-sku-base-amount') || '0');
      const multiplierAttr = itemContainer.getAttribute('data-multiplier');
      const m = Math.max(1, parseInt(multiplierAttr || '5', 10));
      const currentRaw = parseInt(input.value) || 1;
      const remainingCapacity = Math.max(0, maxLimit - currentTotal);
      const maxAllowedEffective = baseAmount > 0 ? Math.floor(remainingCapacity / baseAmount) : 0;
      const allowedRawIncrement = maxAllowedEffective * m;
      
      input.removeAttribute('max');
      if (allowedRawIncrement > 0) {
        input.setAttribute('max', String(currentRaw + allowedRawIncrement));
      } else {
        input.setAttribute('max', String(currentRaw));
      }
    }
  });
}

function updateProductPageButtonStates() {
  if (!document.querySelector('.product-form, [data-product-form], .product')) {
    return;
  }
  
  fetch('/cart.js')
    .then(response => response.json())
    .then(cartData => {
      let cartTotal = 0;
      
      cartData.items.forEach((item, index) => {
        // Skip items with administration_type of "Vape" or "Batterie"
        const adminType = (item.properties && item.properties.administration_type) || '';
        if (adminType === 'Vape' || adminType === 'Batterie') {
          return;
        }
        
        let baseAmount = 0;
        
        if (item.properties && item.properties.sku_base_amount) {
          baseAmount = parseFloat(item.properties.sku_base_amount);
        } else if (item.properties && item.properties.base_amount) {
          baseAmount = parseFloat(item.properties.base_amount);
        } else if (item.properties && item.properties._base_amount) {
          baseAmount = parseFloat(item.properties._base_amount);
        } else if (item.base_amount) {
          baseAmount = parseFloat(item.base_amount);
        } else if (item.variant_base_amount) {
          baseAmount = parseFloat(item.variant_base_amount);
        }
        
        if (!isNaN(baseAmount) && baseAmount > 0) {
          const multiplier = parseInt((item.properties && (item.properties.multiplier || (item.properties.administration_type === 'Extrakt' ? 30 : 5))) || '5', 10);
          const m = isNaN(multiplier) || multiplier < 1 ? 5 : multiplier;
          const effectiveQty = Math.max(1, Math.round((item.quantity || 1) / m));
          cartTotal += baseAmount * effectiveQty;
        }
      });
      
      updateProductPlusButtons(cartTotal, 100);
    })
    .catch(error => {
      updateProductPlusButtons(0, 100);
    });
}

function updateProductPlusButtons(currentTotal, maxLimit) {
  const plusButtons = document.querySelectorAll(`
    .qty__adjust-btn--plus,
    .qty__adjust-btn.qty__adjust-btn--plus,
    [data-quantity-plus],
    [data-quantity-button][data-action="increment"],
    .inputCounter__btn--up,
    .quantity__button--plus,
    .btn--plus,
    button[title*="Increase"],
    button[aria-label*="Increase"]
  `);

  plusButtons.forEach((button, index) => {
    let baseAmount = 0;
    
    const form = button.closest('form, .product-form');
    
    if (form) {
      const baseAmountInput = form.querySelector(`
        input[name="properties[sku_base_amount]"],
        input[name="properties[base_amount]"],
        input[name="properties[_base_amount]"],
        input[data-base-amount],
        [data-product-base-amount],
        [data-variant-base-amount],
        [data-sku-base-amount]
      `);
      
      if (baseAmountInput) {
        baseAmount = parseFloat(baseAmountInput.value || baseAmountInput.getAttribute('data-base-amount') || 0);
      }
      
      if (baseAmount === 0) {
        const formBaseAmount = parseFloat(form.getAttribute('data-base-amount') || form.getAttribute('data-product-base-amount') || 0);
        if (formBaseAmount > 0) {
          baseAmount = formBaseAmount;
        }
      }
    }
    
    const wouldExceedLimit = (currentTotal + baseAmount) > maxLimit;
    
    if (wouldExceedLimit && baseAmount > 0) {
      button.disabled = true;
      button.title = `Cannot add more - would exceed ${maxLimit}g/ml limit`;
    } else {
      button.disabled = false;
      button.title = '';
    }
  });
}

function simpleProductPageDisable() {
  const CONFIG = {
    baseAmountSelectors: [
      'input[name="properties[sku_base_amount]"]',
      'input[name="properties[base_amount]"]',
      'input[name="properties[_base_amount]"]', 
      '[data-base-amount]',
      '[data-product-base-amount]',
      '[data-sku-base-amount]',
      'input[data-base-amount]'
    ],
    
    plusButtonSelectors: [
      '.qty__adjust-btn--plus',
      '.qty__adjust-btn.qty__adjust-btn--plus'
    ],
    
    maxLimit: 100
  };
  
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      let cartTotal = 0;
      
      cart.items.forEach(item => {
        // Skip items with administration_type of "Vape" or "Batterie"
        const adminType = (item.properties && item.properties.administration_type) || '';
        if (adminType === 'Vape' || adminType === 'Batterie') {
          return;
        }
        
        let itemBaseAmount = 0;
        
        if (item.properties) {
          itemBaseAmount = parseFloat(item.properties.sku_base_amount ||
                                   item.properties.base_amount || 
                                   item.properties._base_amount || 
                                   item.properties['sku_base_amount'] ||
                                   item.properties['base_amount'] ||
                                   item.properties['_base_amount'] || 0);
        }
        
        if (itemBaseAmount === 0) {
          itemBaseAmount = parseFloat(item.base_amount || 
                                    item.variant_base_amount || 
                                    item.weight || 0);
        }
        
        if (itemBaseAmount > 0) {
          const multiplier = parseInt((item.properties && (item.properties.multiplier || (item.properties.administration_type === 'Extrakt' ? 30 : 5))) || '5', 10);
          const m = isNaN(multiplier) || multiplier < 1 ? 5 : multiplier;
          const effectiveQty = Math.max(1, Math.round((item.quantity || 1) / m));
          cartTotal += itemBaseAmount * effectiveQty;
        }
      });
      
      const isCartAtLimit = cartTotal >= CONFIG.maxLimit;
      const isCartNearLimit = cartTotal >= (CONFIG.maxLimit * 0.95);
      
      let productBaseAmount = 0;
      
      for (let selector of CONFIG.baseAmountSelectors) {
        const element = document.querySelector(selector);
        if (element) {
          productBaseAmount = parseFloat(element.value || element.getAttribute('data-base-amount') || 0);
          if (productBaseAmount > 0) {
            break;
          }
        }
      }
      
      const shouldDisable = isCartAtLimit || (productBaseAmount > 0 && (cartTotal + productBaseAmount) > CONFIG.maxLimit);
      
      CONFIG.plusButtonSelectors.forEach(selector => {
        const buttons = document.querySelectorAll(selector);
        
        buttons.forEach((button, index) => {
          if (shouldDisable) {
            let disableReason = '';
            if (isCartAtLimit) {
              disableReason = `Warenkorb-Limit erreicht! (${cartTotal}g/${CONFIG.maxLimit}g)`;
            } else {
              disableReason = `Adding would exceed limit! (${cartTotal}g + ${productBaseAmount}g > ${CONFIG.maxLimit}g)`;
            }
            
            button.disabled = true;
            button.title = disableReason;
          } else {
            button.disabled = false;
            button.title = '';
          }
        });
      });
    })
    .catch(error => {
    });
}

function globalDisableIncrementButtons() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Recompute cart total in g/ml using effective quantities per item multiplier
      let cartTotal = 0;
      cart.items.forEach(item => {
        let itemBaseAmount = 0;
        if (item.properties) {
          itemBaseAmount = parseFloat(item.properties.sku_base_amount ||
                                   item.properties.base_amount || 
                                   item.properties._base_amount || 
                                   item.properties['sku_base_amount'] ||
                                   item.properties['base_amount'] ||
                                   item.properties['_base_amount'] || 0);
        }
        if (itemBaseAmount === 0) {
          itemBaseAmount = parseFloat(item.base_amount || item.variant_base_amount || item.weight || 0);
        }
        if (itemBaseAmount > 0) {
          const multiplier = parseInt((item.properties && (item.properties.multiplier || (item.properties.administration_type === 'Extrakt' ? 30 : 5))) || '5', 10);
          const m = isNaN(multiplier) || multiplier < 1 ? 5 : multiplier;
          const effectiveQty = Math.max(1, Math.round((item.quantity || 1) / m));
          cartTotal += itemBaseAmount * effectiveQty;
        }
      });
      const shouldDisableGlobally = cartTotal >= 100;
      
      const allIncrementButtons = document.querySelectorAll(`
        .qty__adjust-btn--plus,
        .qty__adjust-btn.qty__adjust-btn--plus,
        [data-quantity-plus],
        .quantity-plus,
        .btn-plus,
        button[aria-label*="Increase"],
        button[title*="Increase"]
      `);
      
      allIncrementButtons.forEach((button, index) => {
        if (shouldDisableGlobally) {
          button.disabled = true;
          button.title = 'Cart limit reached - cannot add more items';
        } else {
          button.disabled = false;
          button.title = '';
        }
      });
    })
    .catch(error => {
    });
}

function simpleIncrementDisable() {
  const testSelectors = [
    '.qty__adjust-btn--plus',
    '.qty__adjust-btn.qty__adjust-btn--plus',
    '[data-quantity-plus]',
    '[data-quantity-button]',
    '.inputCounter__btn--up',
    '.quantity__button--plus',
    '.btn--plus',
    'button[aria-label*="Increase"]',
    'button[title*="Increase"]',
    '.quantity-selector .btn',
    'button[type="button"]'
  ];
  
  if (true) {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        // Compute limit based on effective grams/ml only
        let cartTotal = 0;
        cart.items.forEach(item => {
          let itemBaseAmount = 0;
          if (item.properties) {
            itemBaseAmount = parseFloat(item.properties.sku_base_amount ||
                                     item.properties.base_amount || 
                                     item.properties._base_amount || 
                                     item.properties['sku_base_amount'] ||
                                     item.properties['base_amount'] ||
                                     item.properties['_base_amount'] || 0);
          }
          if (itemBaseAmount === 0) {
            itemBaseAmount = parseFloat(item.base_amount || item.variant_base_amount || item.weight || 0);
          }
          if (itemBaseAmount > 0) {
            const multiplier = parseInt((item.properties && (item.properties.multiplier || (item.properties.administration_type === 'Extrakt' ? 30 : 5))) || '5', 10);
            const m = isNaN(multiplier) || multiplier < 1 ? 5 : multiplier;
            const effectiveQty = Math.max(1, Math.round((item.quantity || 1) / m));
            cartTotal += itemBaseAmount * effectiveQty;
          }
        });
        const shouldDisable = cartTotal >= 100;
        
        // Always enable decrement buttons
        const decrementSelectors = [
          '.qty__adjust-btn--minus',
          '.qty__adjust-btn.qty__adjust-btn--minus',
          '[data-quantity-minus]',
          '[data-quantity-button][data-action="decrement"]',
          '.inputCounter__btn--down',
          '.quantity__button--minus',
          '.btn--minus',
          'button[aria-label*="Decrease"]',
          'button[title*="Decrease"]'
        ];
        
        decrementSelectors.forEach(selector => {
          const buttons = document.querySelectorAll(selector);
          buttons.forEach(btn => {
            btn.disabled = false;
            btn.style.removeProperty('opacity');
            btn.style.removeProperty('cursor');
          });
        });
        
        if (shouldDisable) {
          let totalButtonsDisabled = 0;
          const incrementSelectors = [
            '.qty__adjust-btn--plus',
            '.qty__adjust-btn.qty__adjust-btn--plus', 
            '[data-quantity-plus]',
            '[data-quantity-button][data-action="increment"]',
            '.inputCounter__btn--up',
            '.quantity__button--plus',
            '.btn--plus',
            'button[aria-label*="Increase"]',
            'button[title*="Increase"]',
            '.quantity-selector .btn:last-child'
          ];
          
          incrementSelectors.forEach(selector => {
            const buttons = document.querySelectorAll(selector);
            if (buttons.length > 0) {
              buttons.forEach(btn => {
                btn.disabled = true;
                totalButtonsDisabled++;
              });
            }
          });
        } else {
          let totalButtonsEnabled = 0;
          const incrementSelectors = [
            '.qty__adjust-btn--plus',
            '.qty__adjust-btn.qty__adjust-btn--plus',
            '[data-quantity-plus]',
            '[data-quantity-button][data-action="increment"]',
            '.inputCounter__btn--up',
            '.quantity__button--plus',
            '.btn--plus',
            'button[aria-label*="Increase"]',
            'button[title*="Increase"]',
            '.quantity-selector .btn:last-child'
          ];
          
          incrementSelectors.forEach(selector => {
            const buttons = document.querySelectorAll(selector);
            if (buttons.length > 0) {
              buttons.forEach(btn => {
                btn.disabled = false;
                totalButtonsEnabled++;
              });
            }
          });
        }
      });
  }
}

document.addEventListener('DOMContentLoaded', function() {
  window.updateProgressBar = updateProgressBar;
  
  document.addEventListener('cart:update', function() {
    debounceProgressBar(updateProgressBar, 200);
  });
  
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-cart-toggle]')) {
      setTimeout(updateProgressBar, 400);
      setTimeout(updateProgressBar, 900);
      setTimeout(checkAndDisableAddToCartButtons, 1000);
    }
  });
  

  
        // Update progress bar when quantity buttons are clicked - polling approach
  let clickCount = 0;
  let pollCount = 0;
  
  function pollForCartUpdate(expectedChange, maxPolls = 10) {
    pollCount++;

    
    fetch('/cart?section_id=api-cart-items')
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const items = doc.querySelectorAll('[data-sku-base-amount]');
        
        let currentTotal = 0;
        items.forEach(item => {
          // Skip items with administration_type of "Vape" or "Batterie"
          const adminType = item.getAttribute('data-administration-type') || '';
          if (adminType === 'Vape' || adminType === 'Batterie') {
            return;
          }
          
          const baseAmount = parseFloat(item.getAttribute('data-sku-base-amount'));
          const multiplier = parseInt(item.getAttribute('data-multiplier') || '5', 10);
          const m = isNaN(multiplier) || multiplier < 1 ? 5 : multiplier;
          const quantityInput = item.querySelector('[data-quantity-field]');
          const rawQuantity = quantityInput ? parseInt(quantityInput.value) : 1;
          const quantity = !isNaN(rawQuantity) ? Math.max(1, Math.round(rawQuantity / m)) : 1;
          
          if (!isNaN(baseAmount) && !isNaN(quantity)) {
            currentTotal += baseAmount * quantity;
          }
        });
        

        
                      if (currentTotal === expectedChange.to) {
            updateProgressDisplay(currentTotal, 100);
          pollCount = 0;
        } else if (pollCount < maxPolls) {
          setTimeout(() => pollForCartUpdate(expectedChange, maxPolls), 200);
                      } else {
            updateProgressDisplay(currentTotal, 100);
          pollCount = 0;
        }
      })
                  .catch(error => {
          pollCount = 0;
        });
  }
  
  document.addEventListener('click', function(e) {
    if (e.target.matches('[data-quantity-button]') || 
        e.target.matches('[data-quantity-plus]') || 
        e.target.matches('[data-quantity-minus]') ||
        e.target.closest('[data-quantity-button]') ||
        e.target.closest('.inputCounter__btn') ||
        e.target.classList.contains('inputCounter__btn') ||
        e.target.parentElement?.classList.contains('inputCounter__btn')) {
      
      clickCount++;
      
      const currentItems = document.querySelectorAll('[data-sku-base-amount]');
      let currentTotal = 0;
      currentItems.forEach(item => {
        // Skip items with administration_type of "Vape" or "Batterie"
        const adminType = item.getAttribute('data-administration-type') || '';
        if (adminType === 'Vape' || adminType === 'Batterie') {
          return;
        }
        
        const baseAmount = parseFloat(item.getAttribute('data-sku-base-amount'));
        const multiplier = parseInt(item.getAttribute('data-multiplier') || '5', 10);
        const m = isNaN(multiplier) || multiplier < 1 ? 5 : multiplier;
        const quantityInput = item.querySelector('[data-quantity-field]');
        const rawQuantity = quantityInput ? parseInt(quantityInput.value) : 1;
        const quantity = !isNaN(rawQuantity) ? Math.max(1, Math.round(rawQuantity / m)) : 1;
        
        if (!isNaN(baseAmount) && !isNaN(quantity)) {
          currentTotal += baseAmount * quantity;
        }
      });
      
      const isIncrement = e.target.closest('.inputCounter__btn--up') || 
                        e.target.closest('[data-quantity-plus]') ||
                        e.target.matches('[data-quantity-plus]');
      
      const row = (e.target.closest('[data-item]') || e.target.closest('[data-sku-base-amount]'));
      
      // Check if the item being modified is Vape or Batterie (shouldn't affect progress bar)
      const rowAdminType = row?.getAttribute('data-administration-type') || '';
      const isVapeOrBatterie = rowAdminType === 'Vape' || rowAdminType === 'Batterie';
      
      const baseAmount = !isVapeOrBatterie ? parseFloat(row?.getAttribute('data-sku-base-amount') || '0') : 0;
      const m = Math.max(1, parseInt(row?.getAttribute('data-multiplier') || '5', 10));
      const expectedNewTotal = currentTotal + (isIncrement ? baseAmount : -baseAmount);
      
      updateIncrementButtonStates(expectedNewTotal, 100);
      
      setTimeout(() => {
        updateIncrementButtonStates(expectedNewTotal, 100);
      }, 50);
      
      setTimeout(() => {
        updateIncrementButtonStates(expectedNewTotal, 100);
      }, 150);
      
      setTimeout(() => {
        const liveTotal = calculateCurrentTotal();
        updateIncrementButtonStates(liveTotal, 100);
      }, 200);
      
      setTimeout(() => {
        const liveTotal = calculateCurrentTotal();
        updateIncrementButtonStates(liveTotal, 100);
      }, 500);
      
      const expectedChange = {
        from: currentTotal,
        to: expectedNewTotal
      };
      
      setTimeout(() => pollForCartUpdate(expectedChange), 100);
    }
  }, true);
                  
    document.addEventListener('click', function(e) {
    if (e.target.matches('[data-item-remove]') || 
        e.target.closest('[data-item-remove]') ||
        e.target.classList.contains('cart-product__remove') ||
        e.target.closest('.cart-product__remove')) {
      
      const itemRow = e.target.closest('[data-item]');
      if (itemRow) {
        // Check if the item being removed is Vape or Batterie (shouldn't affect progress bar)
        const itemAdminType = itemRow.getAttribute('data-administration-type') || '';
        const isVapeOrBatterie = itemAdminType === 'Vape' || itemAdminType === 'Batterie';
        
        const baseAmount = parseFloat(itemRow.getAttribute('data-sku-base-amount'));
        const multiplier = parseInt(itemRow.getAttribute('data-multiplier') || '5', 10);
        const m = isNaN(multiplier) || multiplier < 1 ? 5 : multiplier;
        const quantityInput = itemRow.querySelector('[data-quantity-field]');
        const rawQuantity = quantityInput ? parseInt(quantityInput.value) : 1;
        const quantity = !isNaN(rawQuantity) ? Math.max(1, Math.round(rawQuantity / m)) : 1;
        
        // Only calculate removedAmount if it's not Vape or Batterie
        const removedAmount = (!isNaN(baseAmount) && !isNaN(quantity) && !isVapeOrBatterie) ? baseAmount * quantity : 0;
        
        const currentItems = document.querySelectorAll('[data-sku-base-amount]');
        let currentTotal = 0;
        currentItems.forEach(item => {
          // Skip items with administration_type of "Vape" or "Batterie"
          const adminType = item.getAttribute('data-administration-type') || '';
          if (adminType === 'Vape' || adminType === 'Batterie') {
            return;
          }
          
          const itemBaseAmount = parseFloat(item.getAttribute('data-sku-base-amount'));
          const itemMultiplier = parseInt(item.getAttribute('data-multiplier') || '5', 10);
          const im = isNaN(itemMultiplier) || itemMultiplier < 1 ? 5 : itemMultiplier;
          const itemQuantityInput = item.querySelector('[data-quantity-field]');
          const itemRawQuantity = itemQuantityInput ? parseInt(itemQuantityInput.value) : 1;
          const itemQuantity = !isNaN(itemRawQuantity) ? Math.max(1, Math.round(itemRawQuantity / im)) : 1;
          
          if (!isNaN(itemBaseAmount) && !isNaN(itemQuantity)) {
            currentTotal += itemBaseAmount * itemQuantity;
          }
        });
        
        const expectedNewTotal = currentTotal - removedAmount;
          
          updateIncrementButtonStates(expectedNewTotal, 100);
          
          setTimeout(() => {
            updateIncrementButtonStates(expectedNewTotal, 100);
          }, 50);
          
          setTimeout(() => {
            updateIncrementButtonStates(expectedNewTotal, 100);
          }, 150);
          
          setTimeout(() => {
            const liveTotal = calculateCurrentTotal();
            updateIncrementButtonStates(liveTotal, 100);
          }, 200);
          
          setTimeout(() => {
            const liveTotal = calculateCurrentTotal();
            updateIncrementButtonStates(liveTotal, 100);
          }, 500);
          
          const expectedChange = {
            from: currentTotal,
            to: expectedNewTotal
          };
          
          setTimeout(() => pollForCartUpdate(expectedChange), 100);
        }
      }
  }, true);
  
  document.addEventListener('blur', function(e) {
    if (e.target.matches('[data-quantity-field]')) {
      setTimeout(updateProgressBar, 200);
    }
  });
  
  document.addEventListener('change', function(e) {
    if (e.target.matches('[data-quantity-field]')) {
      const input = e.target;
      const row = input.closest('[data-item]');
      const m = Math.max(1, parseInt(row?.getAttribute('data-multiplier') || input.getAttribute('data-multiplier') || '5', 10));
      let raw = parseInt(input.value) || 1;
      raw = Math.max(m, Math.round(raw / m) * m);
      input.value = String(raw);
      setTimeout(updateProgressBar, 200);
    }
  });
  
  document.addEventListener('input', function(e) {
    if (e.target.matches('[data-quantity-field]')) {
      const input = e.target;
      const row = input.closest('[data-item]');
      const m = Math.max(1, parseInt(row?.getAttribute('data-multiplier') || input.getAttribute('data-multiplier') || '5', 10));
      let raw = parseInt(input.value) || 1;
      if (raw % m !== 0) {
        // Visual snap while typing
        raw = Math.max(m, Math.round(raw / m) * m);
        input.value = String(raw);
      }
      debounceProgressBar(updateProgressBar, 300);
    }
  });
  
  document.addEventListener('submit', function(e) {
    if (e.target.closest('.cart')) {
      setTimeout(updateProgressBar, 300);
    }
  });
  
  debounceProgressBar(updateProgressBar, 500);
  
  setTimeout(() => {
    updateProgressBar();
    setTimeout(() => updateProgressBar(), 100);
    setTimeout(() => updateProgressBar(), 300);
  }, 100);
  
  const progressElement = document.querySelector('[data-progress-amount]');
  if (progressElement) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          const text = progressElement.textContent;
          const match = text.match(/(\d+(?:\.\d+)?)g\/ml/);
          if (match) {
            const currentTotal = parseFloat(match[1]);
            updateIncrementButtonStates(currentTotal, 100);
            checkAndDisableAddToCartButtons();
          }
        }
      });
    });
    
    observer.observe(progressElement, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
  
  const shopifyCartEvents = [
    'cart:updated',
    'cart:change', 
    'cart:build',
    'cart:requestComplete',
    'ajaxCart:updated',
    'ajaxProduct:added',
    'ajaxProduct:removed'
  ];
  
  shopifyCartEvents.forEach(eventName => {
    document.addEventListener(eventName, function() {
      console.log(`🔄 ${eventName} event - refreshing button states`);
      setTimeout(() => {
        const currentTotal = calculateCurrentTotal();
        updateIncrementButtonStates(currentTotal, 100);
        checkAndDisableAddToCartButtons();
      }, 100);
    });
  });
  
  if (window.CartJS) {
    CartJS.subscribe('cart.requestComplete', function() {
      console.log('🔄 CartJS update - refreshing button states');
      setTimeout(() => {
        const currentTotal = calculateCurrentTotal();
        updateIncrementButtonStates(currentTotal, 100);
        checkAndDisableAddToCartButtons();
      }, 100);
    });
  }
  
  if (window.theme && window.theme.cart) {
    const originalUpdate = window.theme.cart.update;
    window.theme.cart.update = function() {
      console.log('🔄 Theme cart update - refreshing button states');
      if (originalUpdate) originalUpdate.apply(this, arguments);
      setTimeout(() => {
        const currentTotal = calculateCurrentTotal();
        updateIncrementButtonStates(currentTotal, 100);
        checkAndDisableAddToCartButtons();
      }, 100);
    };
  }
  
  const originalFetch = window.fetch;
  window.fetch = function(url, options) {
    return originalFetch.apply(this, arguments).then(response => {
      if (url.includes('/cart/add.js') || 
          url.includes('/cart/update.js') || 
          url.includes('/cart/change.js') ||
          url.includes('/cart/clear.js')) {
        console.log('🔄 Cart API call detected - refreshing button states');
        setTimeout(() => {
          const currentTotal = calculateCurrentTotal();
          updateIncrementButtonStates(currentTotal, 100);
          checkAndDisableAddToCartButtons();
        }, 200);
      }
      return response;
    });
  };
  
  const originalXHROpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    this._url = url;
    return originalXHROpen.apply(this, arguments);
  };
  
  const originalXHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function() {
    this.addEventListener('loadend', function() {
      if (this._url && (
          this._url.includes('/cart/add.js') || 
          this._url.includes('/cart/update.js') || 
          this._url.includes('/cart/change.js') ||
          this._url.includes('/cart/clear.js'))) {
        console.log('🔄 Cart XHR call detected - refreshing button states');
        setTimeout(() => {
          const currentTotal = calculateCurrentTotal();
          updateIncrementButtonStates(currentTotal, 100);
          checkAndDisableAddToCartButtons();
        }, 200);
      }
    });
    return originalXHRSend.apply(this, arguments);
  };
  
  document.addEventListener('submit', function(e) {
    if (e.target.action && (
        e.target.action.includes('/cart/add') ||
        e.target.action.includes('/cart/update') ||
        e.target.action.includes('/cart/change'))) {
      console.log('🔄 Cart form submission detected - refreshing button states');
      setTimeout(() => {
        const currentTotal = calculateCurrentTotal();
        updateIncrementButtonStates(currentTotal, 100);
        checkAndDisableAddToCartButtons();
      }, 1000);
    }
  });
  
  setInterval(function() {
    updateProgressBar();
  }, 5000);
  
  // 5-Product Cart Limit Functionality
  function checkCartProductLimit() {
    return fetch('/cart.js')
      .then(response => response.json())
      .then(cartData => {
        const uniqueProducts = new Set();
        cartData.items.forEach(item => {
          uniqueProducts.add(item.product_id);
        });
        
        
        return {
          productCount: uniqueProducts.size,
          items: cartData.items
        };
      })
                 .catch(error => {
         return { productCount: 0, items: [] };
       });
  }
  
  function showCartLimitError(message) {
    // Create or update error message
    let errorDiv = document.querySelector('.cart-limit-error');
    if (!errorDiv) {
      errorDiv = document.createElement('div');
      errorDiv.className = 'cart-limit-error';
      errorDiv.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: #f44336;
        color: white;
        padding: 15px 20px;
        border-radius: 5px;
        z-index: 9999;
        box-shadow: 0 4px 8px rgba(0,0,0,0.2);
        font-size: 14px;
        max-width: 300px;
      `;
      document.body.appendChild(errorDiv);
    }
    
    errorDiv.innerHTML = `
      <div style="display: flex; align-items: center; gap: 10px;">
        <span>⚠️</span>
        <div>
          <strong>Warenkorb-Limit erreicht</strong><br>
          ${message}
        </div>
        <button onclick="this.parentElement.parentElement.remove()" style="background: none; border: none; color: white; font-size: 18px; cursor: pointer; margin-left: auto;">×</button>
      </div>
    `;
    
    setTimeout(() => {
      if (errorDiv && errorDiv.parentElement) {
        errorDiv.remove();
      }
    }, 5000);
  }
  
  document.addEventListener('click', function(e) {
    const addToCartButton = e.target.closest('[data-add-to-cart]');
    if (addToCartButton) {
      
      // Helper function to determine unit based on administration type
      function getUnit(adminType) {
        return adminType === 'Extrakt' ? 'ml' : 'g';
      }
      

      
      if (addToCartButton.disabled || addToCartButton.getAttribute('data-blocked') === 'true') {
        console.log('🚫 BUTTON IS DISABLED/BLOCKED - PREVENTING ACTION');
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        showCartLimitError('Cannot add product - 100g/ml limit reached');
        return false;
      }

      
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      const form = addToCartButton.closest('form');
      if (!form) return;
      
      const formData = new FormData(form);
      const variantId = formData.get('id');
      let requestedQuantity = parseInt(formData.get('quantity')) || 1;
      
                 if (!variantId) {
         return;
       }
      
      addToCartButton.setAttribute('disabled', 'disabled');
      addToCartButton.classList.add('loading');
      
      fetch('/cart?section_id=api-cart-items')
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const items = doc.querySelectorAll('[data-sku-base-amount]');
          
          let cartTotal = 0;
          
          items.forEach((item, index) => {
            // Skip items with administration_type of "Vape" or "Batterie"
            const adminType = item.getAttribute('data-administration-type') || '';
            if (adminType === 'Vape' || adminType === 'Batterie') {
              return;
            }
            
            const baseAmount = parseFloat(item.getAttribute('data-sku-base-amount'));
            const multiplier = parseInt(item.getAttribute('data-multiplier') || '5', 10);
            const m = isNaN(multiplier) || multiplier < 1 ? 5 : multiplier;
            const quantityInput = item.querySelector('[data-quantity-field]');
            const rawQuantity = quantityInput ? parseInt(quantityInput.value) : 1;
            const effectiveQty = !isNaN(rawQuantity) ? Math.max(1, Math.round(rawQuantity / m)) : 1;
            

            
            if (!isNaN(baseAmount) && !isNaN(effectiveQty)) {
              cartTotal += baseAmount * effectiveQty;
            }
          });
          
          // Determine unit based on cart contents
          let cartUnit = 'g'; // default
          const cartItems = document.querySelectorAll('[data-item]');
          for (const item of cartItems) {
            const itemAdminType = item.querySelector('[data-administration-type]')?.getAttribute('data-administration-type');
            if (itemAdminType === 'Extrakt') {
              cartUnit = 'ml';
              break;
            }
          }
          if (cartTotal >= 100) {
            showCartLimitError('Cannot add product - 100g/ml limit already reached');
            addToCartButton.disabled = true;
            addToCartButton.classList.remove('loading');
            addToCartButton.title = 'Cart limit reached - cannot add more items';
            addToCartButton.style.setProperty('opacity', '0.5', 'important');
            addToCartButton.style.setProperty('cursor', 'not-allowed', 'important');
            addToCartButton.setAttribute('data-blocked', 'true');
            return;
          }
          
          // Get admin type early - will be reused throughout this function
          const adminType = formData.get('properties[administration_type]') || '';
          const unit = getUnit(adminType);
          
          // Use calculateCurrentTotal (which was working before)
          let currentCartTotal = calculateCurrentTotal();
          
          return checkCartProductLimit()
             .then(async (cartStatus) => {
              // Store cart total in scope accessible to ALL nested functions
              const finalCartTotal = currentCartTotal;
              
              const productAlreadyInCart = cartStatus.items.some(item => item.variant_id == variantId);
              const existingCartItem = cartStatus.items.find(item => item.variant_id == variantId);
              const currentShopifyQuantity = existingCartItem ? existingCartItem.quantity : 0;
              
                               if (cartStatus.productCount >= 5 && !productAlreadyInCart) {
                 showCartLimitError('You can only have 5 different products in your cart at once.');
                 
                 addToCartButton.setAttribute('data-cart-blocked', 'true');
                 addToCartButton.removeAttribute('disabled');
                 addToCartButton.classList.remove('loading');
                 
                 return;
               }
               
               // Check Vape/Batterie limit (max 3 pieces for Vape, max 1 for Batterie)
               const isVapeOrBatterie = adminType === 'Vape' || adminType === 'Batterie';
               if (isVapeOrBatterie) {
                 // Get limit based on admin type
                 const limit = adminType === 'Batterie' ? 1 : 3;
                 let currentQty = 0;
                 
                 // Count all items of this adminType in cart
                 cartStatus.items.forEach(item => {
                   const itemAdminType = (item.properties && item.properties.administration_type) || '';
                   if (itemAdminType === adminType) {
                     // If this is the variant being added, use the new quantity (existing + requested)
                     if (item.variant_id == variantId) {
                       currentQty += (currentShopifyQuantity + requestedQuantity);
                     } else {
                       // Other items of same type, count their current quantity
                       currentQty += item.quantity || 0;
                     }
                   }
                 });
                 
                 // If product not in cart yet, add requested quantity
                 if (!productAlreadyInCart) {
                   currentQty += requestedQuantity;
                 }
                 
                 console.log('🔍 Vape/Batterie limit check:', {
                   adminType: adminType,
                   limit: limit,
                   currentQty: currentQty,
                   requestedQuantity: requestedQuantity,
                   productAlreadyInCart: productAlreadyInCart,
                   currentShopifyQuantity: currentShopifyQuantity
                 });
                 
                 // If would exceed limit, reduce requestedQuantity to fit within limit
                 if (currentQty > limit) {
                   const existingQty = currentQty - requestedQuantity;
                   const maxAllowed = Math.max(0, limit - existingQty);
                   
                   if (maxAllowed <= 0) {
                     // Already at limit, cannot add more
                     showCartLimitError('Maximum ' + limit + ' ' + adminType + ' items allowed in cart. You currently have ' + existingQty + ' items.');
                     
                     addToCartButton.setAttribute('data-cart-blocked', 'true');
                     addToCartButton.removeAttribute('disabled');
                     addToCartButton.classList.remove('loading');
                     
                     return;
                   } else {
                     // Reduce quantity to fit within limit
                     const originalRequested = requestedQuantity;
                     requestedQuantity = maxAllowed;
                     formData.set('quantity', requestedQuantity.toString());
                     
                     const quantityInput = form.querySelector('input[name="quantity"]');
                     if (quantityInput) {
                       quantityInput.value = requestedQuantity.toString();
                     }
                     
                     showCartLimitError('Menge wurde von ' + originalRequested + ' auf ' + requestedQuantity + ' reduziert. Maximal ' + limit + ' ' + adminType + ' Artikel im Warenkorb erlaubt.');
                     console.log('🔧 Reduced Vape/Batterie quantity from ' + originalRequested + ' to ' + requestedQuantity);
                   }
                 }
               }
               

               const allInputs = form.querySelectorAll('input');

               
               let productBaseAmount = 0;
               const baseAmountSelectors = [
                 'input[name="properties[base_amount]"]',
                 'input[name="properties[_base_amount]"]',
                 'input[name="properties[sku_base_amount]"]',
                 '[data-base-amount]',
                 '[data-product-base-amount]',
                 '[data-sku-base-amount]'
               ];
               
               console.log('🔍 TESTING BASE AMOUNT SELECTORS:');
               
               // First check the clicked button itself
               const buttonBaseAmount = addToCartButton.getAttribute('data-sku-base-amount') || 
                                      addToCartButton.getAttribute('data-base-amount');
               console.log(`   🔍 Button data-sku-base-amount raw: "${buttonBaseAmount}"`);
               console.log(`   🔍 Button data-sku-base-amount type: ${typeof buttonBaseAmount}`);
               
               if (buttonBaseAmount) {
                 productBaseAmount = parseFloat(buttonBaseAmount);
                 console.log(`   🔍 parseFloat result: ${productBaseAmount}`);
                 console.log(`   🔍 parseFloat type: ${typeof productBaseAmount}`);
                 console.log(`   🔍 isNaN check: ${isNaN(productBaseAmount)}`);
                 console.log(`   🔍 productBaseAmount > 0: ${productBaseAmount > 0}`);
                 
                 if (!isNaN(productBaseAmount) && productBaseAmount > 0) {
                   // Get admin type to determine unit
                   const formData = new FormData(form);
                   const adminType = formData.get('properties[administration_type]') || '';
                   const unit = getUnit(adminType);
                   console.log(`   ✅ Using button base amount: ${productBaseAmount}${unit}`);
                 } else {
                   console.log(`   ❌ Button base amount invalid, resetting to 0`);
                   productBaseAmount = 0;
                 }
               }
               
               // If not found on button, check form inputs
               if (productBaseAmount === 0) {
                 for (let selector of baseAmountSelectors) {
                   const element = form.querySelector(selector);
                   console.log(`   ${selector}: ${element ? 'FOUND' : 'NOT FOUND'}`);
                   if (element) {
                     const value = parseFloat(element.value || element.getAttribute('data-base-amount') || element.getAttribute('data-sku-base-amount') || 0);
                     console.log(`     Value: ${value}g`);
                     if (value > 0) {
                       productBaseAmount = value;
                       console.log(`     ✅ Using this value: ${productBaseAmount}g`);
                       break;
                     }
                   }
                 }
               }
               
               if (productBaseAmount === 0) {
                 console.log('⚠️ NO BASE AMOUNT FOUND - Checking alternative sources...');
                 
                 const metaBaseAmount = document.querySelector('meta[name="product-base-amount"]');
                 if (metaBaseAmount) {
                   productBaseAmount = parseFloat(metaBaseAmount.getAttribute('content') || 0);
                   console.log(`   Found in meta tag: ${productBaseAmount}g`);
                 }
                 
                 if (productBaseAmount === 0 && window.product) {
                   console.log('   Checking window.product data...');
                   if (window.product.metafields && window.product.metafields.base_amount) {
                     productBaseAmount = parseFloat(window.product.metafields.base_amount);
                     console.log(`   Found in product metafields: ${productBaseAmount}g`);
                   }
                 }
                 
                 if (productBaseAmount === 0) {
                   const productData = form.closest('.product')?.querySelector('[data-product-json]');
                   if (productData) {
                     try {
                       const product = JSON.parse(productData.textContent);
                       console.log('   Product JSON data:', product);
                       if (product.metafields && product.metafields.base_amount) {
                         productBaseAmount = parseFloat(product.metafields.base_amount);
                         console.log(`   Found in product JSON: ${productBaseAmount}g`);
                       }
                     } catch (e) {
                       console.log('   Could not parse product JSON');
                     }
                   }
                 }
               }
               
                                  if (productBaseAmount === 0) {
                 console.log('⚠️ STILL NO BASE AMOUNT - Using same method as progress bar...');
                 
                 try {
                   // Same method as progress bar: fetch cart HTML and check existing pattern
                   const cartResponse = await fetch('/cart?section_id=api-cart-items');
                   const cartHtml = await cartResponse.text();
                   console.log('   📄 Got cart HTML section (same as progress bar)');
                   
                   const parser = new DOMParser();
                   const doc = parser.parseFromString(cartHtml, 'text/html');
                   const existingCartItem = doc.querySelector(`[data-variant-id="${variantId}"]`);
                   
                   if (existingCartItem) {
                     const existingBaseAmount = existingCartItem.getAttribute('data-sku-base-amount');
                     if (existingBaseAmount) {
                       productBaseAmount = parseFloat(existingBaseAmount);
                       console.log(`   ✅ Found existing item in cart with data-sku-base-amount: ${productBaseAmount}g`);
                     }
                   } else {
                     console.log('   ⚠️ Product not in cart yet - checking page DOM for metafield data...');
                     
                     // Check if metafield is available in page JavaScript
                     if (window.meta && window.meta.product) {
                       console.log('   🔍 Checking window.meta.product:', window.meta.product);
                       if (window.meta.product.metafields && window.meta.product.metafields.custom && window.meta.product.metafields.custom.sku_base_amount) {
                         productBaseAmount = parseFloat(window.meta.product.metafields.custom.sku_base_amount);
                         console.log(`   ✅ Found in window.meta.product.metafields.custom.sku_base_amount: ${productBaseAmount}g`);
                       }
                     }
                     
                     // Check ShopifyAnalytics
                     if (productBaseAmount === 0 && window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
                       console.log('   🔍 Checking ShopifyAnalytics.meta.product:', window.ShopifyAnalytics.meta.product);
                       const analyticsProduct = window.ShopifyAnalytics.meta.product;
                       if (analyticsProduct.metafields && analyticsProduct.metafields.custom && analyticsProduct.metafields.custom.sku_base_amount) {
                         productBaseAmount = parseFloat(analyticsProduct.metafields.custom.sku_base_amount);
                         console.log(`   ✅ Found in ShopifyAnalytics metafields: ${productBaseAmount}g`);
                       }
                     }
                     
                     // Check if there's a data attribute in the page
                     if (productBaseAmount === 0) {
                       const productContainer = document.querySelector('.product, [data-product], .product-single, .product-form');
                       if (productContainer) {
                         const pageBaseAmount = productContainer.getAttribute('data-sku-base-amount') || 
                                              productContainer.getAttribute('data-base-amount') ||
                                              productContainer.querySelector('[data-sku-base-amount]')?.getAttribute('data-sku-base-amount');
                         if (pageBaseAmount) {
                           productBaseAmount = parseFloat(pageBaseAmount);
                           console.log(`   ✅ Found data-sku-base-amount in page DOM: ${productBaseAmount}g`);
                         }
                       }
                     }
                   }
                   
                 } catch (error) {
                   console.log('   ❌ Error using progress bar method:', error);
                 }
                 
                 if (productBaseAmount === 0) {
                   console.log('   ❌ NO BASE AMOUNT FOUND - Same issue as progress bar would have!');
                   console.log('   💡 The progress bar gets data from [data-sku-base-amount] attributes in cart HTML');
                   console.log('   💡 These attributes come from your Liquid template that renders: {{ item.properties.sku_base_amount }}');
                   console.log('   💡 Add sku_base_amount to your product form so it gets saved to cart properties!');
                   showCartLimitError('No base amount data found. Progress bar uses the same method.');
                   addToCartButton.removeAttribute('disabled');
                   addToCartButton.classList.remove('loading');
                   return;
                 }
               }
               

               
               // DEBUG: Show current values
               console.log('🚨 DEBUGGING VALUES:');
               console.log('   finalCartTotal:', finalCartTotal, 'g');
               console.log('   productBaseAmount:', productBaseAmount, 'g');
               console.log('   requestedQuantity:', requestedQuantity);
               console.log('   Potential total:', finalCartTotal + (requestedQuantity * productBaseAmount), 'g');
               
               // FIXED: Simple total cart limit check
               const MAX_LIMIT = 100;
               // requestedQuantity may have been reduced by Vape/Batterie limit check above
               let finalQuantity = requestedQuantity;
               
               // Account for the multiplier system that will multiply our quantity
               // Vape and Batterie don't use multiplier (multiplier = 1)
               const multiplier = adminType === 'Vape' || adminType === 'Batterie' ? 1 : (adminType === 'Extrakt' ? 30 : 5);
               const actualShopifyQuantity = requestedQuantity * multiplier;
               console.log('🔍 MULTIPLIER INFO:');
               console.log('   Admin type:', adminType);
               console.log('   Multiplier:', multiplier);
               console.log('   Requested quantity (before multiplier):', requestedQuantity);
               console.log('   Actual quantity that will be sent to Shopify:', actualShopifyQuantity);
               
               console.log('🔍 EXISTING CART ITEM CHECK:');
               console.log('   Product already in cart:', productAlreadyInCart);
               console.log('   Current Shopify quantity in cart:', currentShopifyQuantity);
               console.log('   Trying to add Shopify quantity:', actualShopifyQuantity);
               console.log('   Total Shopify quantity would be:', currentShopifyQuantity + actualShopifyQuantity);
               
               // Check if the total Shopify quantity would be too high
               const totalShopifyQuantity = currentShopifyQuantity + actualShopifyQuantity;
               if (totalShopifyQuantity > 999) {
                 console.log('🚫 BLOCKING: Total Shopify quantity would be too high (' + totalShopifyQuantity + ')');
                 showCartLimitError('Cannot add this quantity. This would result in too many items in your cart for this product.');
                 addToCartButton.removeAttribute('disabled');
                 addToCartButton.classList.remove('loading');
                 return;
               }
               
               // Calculate what the TOTAL cart would be after adding requested items
               const potentialCartTotal = finalCartTotal + (requestedQuantity * productBaseAmount);
               
               console.log('🔍 LIMIT CHECK:');
               console.log('   Will exceed limit?', potentialCartTotal > MAX_LIMIT);
               console.log('   Calculation:', finalCartTotal, '+', '(' + requestedQuantity, '×', productBaseAmount + ')', '=', potentialCartTotal);
               
               // If adding all requested items would exceed 100g total, reduce quantity
               if (potentialCartTotal > MAX_LIMIT) {
                 console.log('🚫 REDUCING QUANTITY - WOULD EXCEED LIMIT');
                 
                 // Calculate how much space is left in the cart
                 const spaceLeft = MAX_LIMIT - finalCartTotal;
                 
                 // Calculate max items that fit in remaining space
                 const maxItemsThatFit = Math.floor(spaceLeft / productBaseAmount);
                 
                 console.log('   Space left:', spaceLeft, 'g');
                 console.log('   Max items that fit:', maxItemsThatFit);
                 
                 if (maxItemsThatFit <= 0) {
                   console.log('🚫 NO SPACE - BLOCKING COMPLETELY');
                   showCartLimitError('Cart is full (100g/ml limit). Cannot add any more items.');
                   addToCartButton.disabled = true;
                   addToCartButton.classList.remove('loading');
                   return;
                 }
                 
                 // Reduce quantity to what fits
                 finalQuantity = maxItemsThatFit;
                 console.log('   Reduced quantity to:', finalQuantity);
                 
                 showCartLimitError(`Quantity reduced from ${requestedQuantity} to ${finalQuantity}. Total cart limit is 100g/ml.`);
               } else {
                 console.log('✅ QUANTITY OK - WITHIN LIMIT');
               }
               
               // Double-check: verify final total doesn't exceed limit
               const finalCartCheck = finalCartTotal + (finalQuantity * productBaseAmount);
               console.log('🔍 FINAL SAFETY CHECK:');
               console.log('   Final cart total will be:', finalCartCheck, 'g');
               console.log('   Exceeds limit?', finalCartCheck > MAX_LIMIT);
               
               if (finalCartCheck > MAX_LIMIT) {
                 console.log('🚨 FINAL SAFETY CHECK FAILED - BLOCKING');
                 showCartLimitError('Error: Cannot add items without exceeding 100g/ml limit.');
                 addToCartButton.removeAttribute('disabled');
                 addToCartButton.classList.remove('loading');
                 return;
               }
               
               console.log('🎯 FINAL VALUES TO SEND:');
               console.log('   Quantity to add:', finalQuantity);
               // Get unit based on adminType
               const unit = getUnit(adminType);
               console.log('   Expected cart total after:', finalCartCheck, unit);
               
               // Warn if the multiplied quantity might cause Shopify inventory issues
               const finalShopifyQuantity = finalQuantity * multiplier;
               console.log('   Shopify will receive quantity:', finalShopifyQuantity);
               if (finalShopifyQuantity > 100) {
                 console.log('⚠️ WARNING: High quantity being sent to Shopify (' + finalShopifyQuantity + ') - this might trigger inventory limits');
               }
               
               formData.set('quantity', finalQuantity.toString());
               
               const quantityInput = form.querySelector('input[name="quantity"]');
               if (quantityInput) {
                 quantityInput.value = finalQuantity.toString();
               }
               
               addToCartButton.removeAttribute('data-cart-blocked');
               
               return { finalQuantity, finalCartTotal, productBaseAmount, requestedQuantity, adminType };
             });
         })
                                            .then((result) => {
          console.log('🔍 PROMISE RESULT:', result);
          console.log('   result exists:', !!result);
          console.log('   result.finalQuantity:', result?.finalQuantity);
          console.log('   typeof finalQuantity:', typeof result?.finalQuantity);
          
          if (!result || !result.finalQuantity) {
            console.log('❌ EARLY RETURN: result or finalQuantity is falsy');
            return;
          }
           
                     const { finalQuantity, finalCartTotal, productBaseAmount, requestedQuantity, adminType } = result;
          const safeQuantity = Math.max(1, finalQuantity);
          
           const unit = getUnit(adminType);
           
           if (finalCartTotal + (safeQuantity * productBaseAmount) > 100) {
             console.log('🚨 ERROR: ABOUT TO SEND REQUEST THAT WILL EXCEED LIMIT!');
             console.log('🚨 THIS SHOULD NOT HAPPEN - STOPPING HERE');
             showCartLimitError('CRITICAL ERROR: Quantity calculation failed');
             addToCartButton.removeAttribute('disabled');
             addToCartButton.classList.remove('loading');
             return;
           }
           
           // Apply multiplier before sending to Shopify
          // Vape and Batterie don't use multiplier (multiplier = 1)
          const multiplier = adminType === 'Vape' || adminType === 'Batterie' ? 1 : (adminType === 'Extrakt' ? 30 : 5);
          const shopifyQuantity = safeQuantity * multiplier;
          
          const cartData = {
            id: variantId,
            quantity: shopifyQuantity
          };
           
           for (let [key, value] of formData.entries()) {
             if (key !== 'id' && key !== 'quantity') {
               cartData[key] = value;
             }
           }
           
           
           
           fetch('/cart/add.js', {
             method: 'POST',
             headers: {
               'Content-Type': 'application/json',
               'X-Requested-With': 'XMLHttpRequest'
             },
             body: JSON.stringify(cartData)
           })
                         .then(response => {
             console.log('📡 CART API RESPONSE STATUS:', response.status);
             return response.json();
           })
                         .then(data => {
             console.log('📦 CART API RESPONSE DATA:', data);
             
             if (data.status) {
               console.log('❌ CART API ERROR:', data.description || data.message);
               
               // Handle German inventory limit error
               const errorMessage = data.description || data.message || '';
               if (errorMessage.includes('maximale Menge') || errorMessage.includes('bereits in deinem Warenkorb')) {
                 console.log('🇩🇪 GERMAN INVENTORY ERROR - This is likely due to Shopify inventory limits');
                 console.log('   The multiplier system sent quantity:', finalShopifyQuantity);
                 console.log('   Shopify rejected it due to inventory constraints');
                 showCartLimitError('Product inventory limit reached. Try reducing the quantity or check if the product is already at maximum in your cart.');
               } else {
                 showCartLimitError(errorMessage);
               }
             } else {
               console.log('✅ CART API SUCCESS - ITEM ADDED');
               console.log('   🎯 Requested to add:', safeQuantity);
               console.log('   🎯 Actually added by Shopify:', data.quantity || 'unknown');
               console.log('   🎯 Product title:', data.title || 'unknown');
               const unit = getUnit(adminType);
               console.log('   🎯 Item base amount:', productBaseAmount + unit);
               console.log('   🎯 Shopify quantity added:', data.quantity || safeQuantity);
              console.log('   🎯 Effective units added:', Math.max(1, Math.round((data.quantity || safeQuantity) / multiplier)));
              console.log('   🎯 Total ' + unit + ' added to cart:', Math.max(1, Math.round((data.quantity || safeQuantity) / multiplier)) * productBaseAmount + unit);
               
                             // Verify the cart won't exceed limit
              const actualQuantityAdded = data.quantity || safeQuantity;
              // Convert Shopify quantity back to effective units for calculation
              const effectiveQuantityAdded = Math.max(1, Math.round(actualQuantityAdded / multiplier));
              const actualAmountAdded = effectiveQuantityAdded * productBaseAmount;
              const newCartTotal = finalCartTotal + actualAmountAdded;
               

               
               if (newCartTotal > 100) {
                 console.log('🚨🚨🚨 CRITICAL ERROR: CART EXCEEDS 100' + unit.toUpperCase() + ' LIMIT! 🚨🚨🚨');
                 console.log('🚨 Expected:', newCartTotal + unit + ' (OVER LIMIT!)');
                 console.log('🚨 Our quantity limiting logic FAILED!');
                 console.log('🚨 Debug info:');
                 console.log('   - We sent quantity:', safeQuantity);
                 console.log('   - Shopify added quantity:', actualQuantityAdded);
                 console.log('   - Base amount per item:', productBaseAmount + unit);
                 console.log('   - Cart was:', finalCartTotal + unit);
                 console.log('   - We added:', actualAmountAdded + unit);
                 console.log('🚨 THIS SHOULD NEVER HAPPEN!');
               } else if (newCartTotal === 100) {
                 console.log('✅ PERFECT: Cart total exactly at 100' + unit + ' limit');
               } else {
                 console.log('✅ GOOD: Cart total within limit (' + newCartTotal + unit + ' < 100' + unit + ')');
               }
               
              document.dispatchEvent(new CustomEvent('cart:updated'));
              
              if (window.cart && typeof window.cart.getCart === 'function') {
                window.cart.getCart();
              }
              
              // Check button states again after adding to cart (especially for Vape/Batterie limits)
              setTimeout(() => {
                checkAndDisableAddToCartButtons();
              }, 300);
              
              addToCartButton.classList.add('success');
              setTimeout(() => {
                addToCartButton.classList.remove('success');
              }, 1000);
            }
          })
                         .catch(error => {
             showCartLimitError('Failed to add product to cart. Please try again.');
           })
          .finally(() => {
            addToCartButton.removeAttribute('disabled');
            addToCartButton.classList.remove('loading');
          });
        });
    }
          }, true);
  
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (form.querySelector('[data-add-to-cart]')) {
      const addToCartButton = form.querySelector('[data-add-to-cart]');
                 if (addToCartButton && addToCartButton.getAttribute('data-cart-blocked') === 'true') {
         e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }
    }
  }, true);
  
    checkCartProductLimit();
    
    function checkAndDisableAddToCartButtons() {
      console.log('🔍 CHECKING PAGE LOAD BUTTON STATE...');
      
      let cartTotal = 0;
      
      fetch('/cart?section_id=api-cart-items')
        .then(response => response.text())
        .then(html => {
          console.log('📄 GOT CART HTML SECTION');
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const items = doc.querySelectorAll('[data-sku-base-amount]');
          
          console.log(`🔍 Found ${items.length} items with data-sku-base-amount`);
          
          items.forEach((item, index) => {
            // Skip items with administration_type of "Vape" or "Batterie"
            const adminType = item.getAttribute('data-administration-type') || '';
            if (adminType === 'Vape' || adminType === 'Batterie') {
              return;
            }
            
            const baseAmount = parseFloat(item.getAttribute('data-sku-base-amount'));
            const multiplierAttr = item.getAttribute('data-multiplier') || '5';
            const m = Math.max(1, parseInt(multiplierAttr, 10));
            const quantityInput = item.querySelector('[data-quantity-field]');
            const rawQuantity = quantityInput ? parseInt(quantityInput.value) : 1;
            const effectiveQty = !isNaN(rawQuantity) ? Math.max(1, Math.round(rawQuantity / m)) : 1;
            
            console.log(`Item ${index + 1}: base=${baseAmount}, rawQty=${rawQuantity}, m=${m} → effQty=${effectiveQty}, total+=${baseAmount * effectiveQty}`);
            
            if (!isNaN(baseAmount) && !isNaN(effectiveQty)) {
              cartTotal += baseAmount * effectiveQty;
            }
          });
          
          // Determine unit based on cart contents
          let totalUnit = 'g'; // default
          const cartItems = document.querySelectorAll('[data-item]');
          for (const item of cartItems) {
            const itemAdminType = item.getAttribute('data-administration-type');
            if (itemAdminType === 'Extrakt') {
              totalUnit = 'ml';
              break;
            }
          }
          console.log(`📊 DOM-BASED CART TOTAL: ${cartTotal}${totalUnit} / 100${totalUnit}`);
          
          // Count Vape and Batterie items separately (for limit check, not progress bar)
          let vapeQty = 0;
          let batterieQty = 0;
          const allCartItems = doc.querySelectorAll('[data-item]');
          allCartItems.forEach(item => {
            const itemAdminType = item.getAttribute('data-administration-type') || '';
            const quantityInput = item.querySelector('[data-quantity-field]');
            const qty = quantityInput ? parseInt(quantityInput.value) || 0 : 0;
            if (itemAdminType === 'Vape') {
              vapeQty += qty;
            } else if (itemAdminType === 'Batterie') {
              batterieQty += qty;
            }
          });
          console.log(`🔍 Vape quantity in cart: ${vapeQty} / 3`);
          console.log(`🔍 Batterie quantity in cart: ${batterieQty} / 3`);
          
          const addToCartButtons = document.querySelectorAll('[data-add-to-cart]');
          console.log(`🔍 Found ${addToCartButtons.length} add-to-cart buttons`);
          
          console.log('🔧 Evaluating per-button add allowance based on base amount and multiplier');
          addToCartButtons.forEach((button, index) => {
            const container = button.closest('[data-sku-base-amount]') || 
                              button.closest('[data-item]') ||
                              button.closest('.product-form') ||
                              button.closest('form') ||
                              document.body;
            
            // Check administration type for this product
            const containerAdminType = container?.getAttribute('data-administration-type') || '';
            const isVape = containerAdminType === 'Vape';
            const isBatterie = containerAdminType === 'Batterie';
            
            let baseAmount = 0;
            if (container && container.getAttribute) {
              baseAmount = parseFloat(container.getAttribute('data-sku-base-amount') || '0');
            }
            if (!baseAmount) {
              const alt = container.querySelector && container.querySelector('[data-sku-base-amount]');
              if (alt) baseAmount = parseFloat(alt.getAttribute('data-sku-base-amount') || '0');
            }
            const multiplierAttr = (container && container.getAttribute && container.getAttribute('data-multiplier')) || '5';
            const m = Math.max(1, parseInt(multiplierAttr, 10));
            const addDelta = baseAmount > 0 ? baseAmount : 0;
            const wouldExceed = addDelta > 0 ? (cartTotal + addDelta) > 100 : cartTotal >= 100;
            
            // Check Vape/Batterie limit (max 3 pieces each type)
            const requestedQty = parseInt(container.querySelector('input[name="quantity"]')?.value || '1') || 1;
            
            // Check if this variant is already in cart
            let variantId = null;
            const form = container.closest('form');
            if (form) {
              const formData = new FormData(form);
              variantId = formData.get('id');
            }
            
            // Check Vape/Batterie limit (max 3 pieces each type)
            let wouldExceedVapeLimit = false;
            let wouldExceedBatterieLimit = false;
            
            if (isVape) {
              // If already at or over limit, disable completely
              const vapeLimit = 3;
              if (vapeQty >= vapeLimit) {
                wouldExceedVapeLimit = true;
              } else {
                // Calculate what total would be after adding requested quantity
                // Need to account for this variant already in cart
                let adjustedVapeQty = vapeQty;
                if (variantId) {
                  allCartItems.forEach(item => {
                    const itemVariantId = item.getAttribute('data-variant-id');
                    const itemAdminType = item.getAttribute('data-administration-type') || '';
                    if (itemVariantId == variantId && itemAdminType === 'Vape') {
                      const quantityInput = item.querySelector('[data-quantity-field]');
                      const existingQty = quantityInput ? parseInt(quantityInput.value) || 0 : 0;
                      adjustedVapeQty -= existingQty; // Remove existing qty to see what we can add
                      console.log(`🔍 Found variant ${variantId} in cart with qty ${existingQty}, adjusted Vape count from ${vapeQty} to ${adjustedVapeQty}`);
                    }
                  });
                }
                wouldExceedVapeLimit = (adjustedVapeQty + requestedQty) > vapeLimit;
                console.log(`🔍 Vape limit check: current=${adjustedVapeQty}, requested=${requestedQty}, total=${adjustedVapeQty + requestedQty}, limit=${vapeLimit}, exceeds=${wouldExceedVapeLimit}`);
              }
            }
            
            if (isBatterie) {
              // If already at or over limit, disable completely
              const batterieLimit = 1; // Batterie limit is 1
              if (batterieQty >= batterieLimit) {
                wouldExceedBatterieLimit = true;
              } else {
                // Calculate what total would be after adding requested quantity
                // Need to account for this variant already in cart
                let adjustedBatterieQty = batterieQty;
                if (variantId) {
                  allCartItems.forEach(item => {
                    const itemVariantId = item.getAttribute('data-variant-id');
                    const itemAdminType = item.getAttribute('data-administration-type') || '';
                    if (itemVariantId == variantId && itemAdminType === 'Batterie') {
                      const quantityInput = item.querySelector('[data-quantity-field]');
                      const existingQty = quantityInput ? parseInt(quantityInput.value) || 0 : 0;
                      adjustedBatterieQty -= existingQty; // Remove existing qty to see what we can add
                      console.log(`🔍 Found variant ${variantId} in cart with qty ${existingQty}, adjusted Batterie count from ${batterieQty} to ${adjustedBatterieQty}`);
                    }
                  });
                }
                wouldExceedBatterieLimit = (adjustedBatterieQty + requestedQty) > batterieLimit;
                console.log(`🔍 Batterie limit check: current=${adjustedBatterieQty}, requested=${requestedQty}, total=${adjustedBatterieQty + requestedQty}, limit=${batterieLimit}, exceeds=${wouldExceedBatterieLimit}`);
              }
            }

            const shouldDisable = wouldExceed || wouldExceedVapeLimit || wouldExceedBatterieLimit;
            if (shouldDisable) {
              if (!button.hasAttribute('data-blocked')) {
                button.disabled = true;
                if (wouldExceedVapeLimit) {
                  button.title = ' Maximal 3 Vape-Artikel im Warenkorb erlaubt';
                } else if (wouldExceedBatterieLimit) {
                  button.title = ' Maximal 1 Batterie-Artikel im Warenkorb erlaubt';
                } else {
                  button.title = ' Warenkorblimit erreicht oder würde durch diesen Artikel überschritten werden';
                }
                button.style.setProperty('opacity', '0.5', 'important');
                button.style.setProperty('cursor', 'not-allowed', 'important');
                button.setAttribute('data-blocked', 'true');
                console.log(`🚫 Disabled button ${index + 1}: base=${baseAmount}, cart=${cartTotal}, vapeLimit=${wouldExceedVapeLimit}, batterieLimit=${wouldExceedBatterieLimit}`);
              }
            } else {
              button.disabled = false;
              button.title = '';
              button.style.removeProperty('opacity');
              button.style.removeProperty('cursor');
              button.removeAttribute('data-blocked');
              console.log(`✅ Enabled button ${index + 1}: base=${baseAmount}, cart=${cartTotal}`);
            }
          });
        })
        .catch(error => {
          console.error('❌ Error checking cart status:', error);
        });
    }
    
        checkAndDisableAddToCartButtons();
  

});